import { SVGProps } from 'react'

export function Pipe({ width = 1, height = 36, ...rest }: SVGProps<SVGSVGElement>) {
    return (
        <svg width={width} height={height} viewBox="0 0 1 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <line x1="0.5" y1="2.18557e-08" x2="0.499998" y2="36" stroke="#E6E6E6" />
        </svg>
    )
}
